import { HistoryMessageSegment } from "types/historyMessageTypes";
import { HistoryEntryType } from "Config/Enum/historyEntryType";
import { HistorySegmentType } from "Config/Enum/historySegmentType";
import { AssignedActionMessageBuilder, CompleteActionMessageBuilder } from "./action";
import { NoteMessageBuilder } from "./note/noteMessageBuilder";
import { MessageMessageBuilder } from "./message/messageMessageBuilder";
import { CardMessageBuilder } from "./card/cardMessageBuilder";
import { UserMessageBuilder } from "./user/userMessageBuilder";
import { SystemMessageBuilder } from "./system/systemMessageBuilder";

/**
 * Builder class responsible for constructing history message segments based on entry type.
 *
 * @remarks
 * This class acts as a facade/router that delegates the message building process to
 * specialized builder classes based on the history entry type. It extracts the relevant
 * data from the entry object and routes it to the appropriate builder.
 *
 * @example
 * ```typescript
 * const segments = HistoryMessageBuilder.buildMessage(historyEntry);
 * ```
 */
export class HistoryMessageBuilder {
  //any for now but should be IncidentHistoryType once all the builders are typed
  static buildMessage(entry: any): HistoryMessageSegment[] {
    const type = entry.type;

    // Dispatch to appropriate builder
    switch (type) {
      case HistoryEntryType.ACTION:
        if (!entry.action) return [];
        switch (entry.action.historyActionType) {
          case "COMPLETE":
            return CompleteActionMessageBuilder.build(entry.action);
            break;
          case "INSERT":
            return AssignedActionMessageBuilder.build(entry.action);
        }
        // If no builder exists for this action type, use API response text
        return entry.text ? [{ type: HistorySegmentType.TEXT, content: entry.text }] : [];
      case HistoryEntryType.NOTE:
        return entry.note ? NoteMessageBuilder.build(entry.note) : [];
      case HistoryEntryType.MESSAGE:
        return entry.message ? MessageMessageBuilder.build(entry.message) : [];
      case HistoryEntryType.CARD:
        return entry.card ? CardMessageBuilder.build(entry.card) : [];
      case HistoryEntryType.USER:
        return entry.user ? UserMessageBuilder.build(entry.user) : [];
      case HistoryEntryType.SYSTEM:
        return entry.system ? SystemMessageBuilder.build(entry.system) : [];
      default:
        return [];
    }
  }
}
